import styled from '@emotion/styled';
import { memo } from 'react';
export const TraderVip = memo(function TraderVip() {
    return <div>專業看盤室</div>;
});
const calsses = {
    container: styled.div ``,
};
